import React from 'react'

function Button({ className, value }) {

  return (
    <div className={` ${className} bg-gradient-to-r from-[#8066FF] to-[#FE8888] text-center text-white font-semibold cursor-pointer py-2 px-8 rounded-xl`}>{value}</div>
  )
}

export default Button